export const environment = {
  production: false,
  api: {
    url: 'https://sso-test.staatsanzeiger.de/api/'
  },
  ssoClient: {
    url: 'https://sso-test.staatsanzeiger.de/'
  },
  oidc: {
    url: 'https://sso-test.staatsanzeiger.de/api/oidc/'
  }
};
